import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";

export const LimitCell = <T extends { limit: number | null }>({
    row,
}: CellContext<ViewTableFeatures, T, number | null>) => {
    const limit = row.original.limit;
    if (limit == null) {
        return <span>-</span>;
    }

    return <span>{limit.toLocaleString()}/hour</span>;
};
